export enum SpecialtyEnum {
  OTHERS = 24,
  NO_SPECIALTY = 32
}
